import React, { useEffect, useState } from "react";
import cloneDeep from "lodash/cloneDeep";
import throttle from "lodash/throttle";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
// import { allData } from "./constants";
import storage from "@/utils/storage";

import axios from "axios";
import "./myWinning.css";
import Swal from "sweetalert2";
import { Box, Button, Typography } from "@mui/material";
import { Opacity } from "@material-ui/icons";
import { formatUTCToLocal } from "@/utils/utils";

const WithdrawReqStatus = () => {
  const countPerPage = 10;
  const [value, setValue] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState(10);
  const [data, setData] = useState([
    {
      paymentStatus: "",
      adminRemark: "",

      walletAddress: "",
      amount: "",
      walletNetwork: "",

      withdrawPartialAmtPaid: "",
      withdrawRemainingAmtPaid: "",
      withdrawTotalAmtPaid: "",
      createdAt: "",
      cryptoType: "",
    },
  ]);
  const [collection, setCollection] = React
    .useState
  
    ();
  const [isLoading, setIsLoading] = useState(false);

  
  React.useEffect(() => {
    if (!value) {
      updatePage(1);
    } else {
      //   searchData.current(value);
    }
  }, [value]);

  useEffect(() => {
    getData(value, 1);
  }, [value]);

  const getData = async (value, p) => {
    let token = storage.getToken();
    let pageLimit;
    pageLimit = value != "" ? totalRecords : 10;
    const payable = {
      page: p,
      limit: pageLimit,
    };
    await axios
      .post(
        `${process.env.API_URL_PREFIX}/api/v1/user/fetchUserWithdrawReq?search=${value}`,
        payable,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        setData(res?.data?.data);
        setTotalRecords(res?.data?.totalExternalWallAddCount);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updatePage = (p) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;

    getData(value, p);
  };
  console.log("datalll", data);
  return (
    <>
      <div style={{ overflow: "auto" }}>
        <input
          placeholder="Search"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="search"
          style={{ marginTop: "10px" }}
        />
      </div>
      <div className="table-t1 sticky-table">
        <table style={{ borderCollapse: "collapse", width: "100%" }}>
          {data.length > 0 ? (
          <thead>
            <tr className="table-th">
              <th>Wallet Address</th>
              <th>Payment Req Amount</th>
              <th>Payment Status</th>
              <th style={{ minWidth: "100px" }}>Remark</th>
              <th>Wallet Network</th>
              <th>Token Type</th>
              {/* <th>Payment Type</th> */}
              <th>Withdraw Partial Paid Amt</th>
              <th>Withdraw Remaining Paid Amt</th>
              <th>Withdraw Total Paid Amt</th>
              <th>Created Date</th>
              {/* <th>Payment Request Id</th> */}
            </tr>
          </thead>
          ):""}
          <tbody>
            {data.length > 0 ? (
              data.map((item, i) => (
                <tr key={i} className="table-th2">
                  <td>{item.walletAddress}</td>
                  <td>{item.amount}</td>
                  <td
                    style={{
                      backgroundColor:
                        item.paymentStatus === "checked"
                          ? "#f3e139a6"
                          : item.paymentStatus === "partialPay"
                          ? "lightgreen"
                          : item.paymentStatus === "finalPay"
                          ? "green"
                          : item.paymentStatus === "completed"
                          ? "blue"
                          : item.paymentStatus === "rejected"
                          ? "red"
                          : item.paymentStatus === "Pending"
                          ? "#f7dc6f"
                          : "gray",
                      color:
                        item.paymentStatus === "Pending" ? "black" : "white",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    {item.paymentStatus}
                  </td>
                  <td>{item.adminRemark}</td>
                  <td>{item.walletNetwork}</td>
                  <td>{item.cryptoType}</td>
                  <td>{item.withdrawPartialAmtPaid}</td>
                  <td>{item.withdrawRemainingAmtPaid}</td>
                  <td>{item.withdrawTotalAmtPaid}</td>
                  <td>{formatUTCToLocal(item.createdAt)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="400px"
                    textAlign="center"
                  >
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      style={{ color: "#ff862d" }}
                    >
                      🎉 Every Lottery begins with a blank page <br />
                      ✨ Yours could be the one written in{" "}
                      <strong>gold</strong>! 🏆
                    </Typography>
                  </Box>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {value == "" && totalRecords > 0 && (
        <Pagination
          pageSize={countPerPage}
          onChange={updatePage}
          current={currentPage}
          total={totalRecords}
        />
      )}
    </>
  );
};
export default WithdrawReqStatus;
